/**
 *
 * vue全局设置
 *
 */
// import axios from 'axios'
Vue.use(VueRouter)
    // Vue.use(Vuex)

import _ from 'lodash'
// 阿里可伸缩布局方案
import './lib/lib-flexible'

import fullscreen from "vue-fullscreen";

Vue.use(fullscreen);
// 注册导入滚动组件
import SuperSlide from "./lib/superslide";

Vue.use(SuperSlide);
// import Element from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 1000 };

console.log('process.env.NAME', process.env.NAME);
document.title = process.env.TITLE;
Vue.prototype.PROJECT_LOGO = process.env.LOGO;
Vue.prototype.PROJECT_NAME = process.env.NAME

$('#favicon').attr('href', 'static/img/' + process.env.LOGO + '/favicon.ico')

// import VueDND from 'awe-dnd'
// Vue.use(VueDND)
//全局插件注册
import './registercommonplugin'
import router_list from './router'
//框架内部页面注册
import homepage from '@/components/homepage/index.vue'
Vue.component('homepage', homepage)

import load_iframe from '@/commonplugin/load_iframe.vue'
Vue.component('load_iframe', load_iframe)

import settingpage from '@/components/setting/list.vue'
Vue.component('settingpage', settingpage)




/**
 *
 * 自定义公共方法
 *
 */
import './common'



// 初始化路由
window.router = new VueRouter({
    mode: 'hash',
    routes: router_list,
})

//模块组件信息
window.allCOM = []
    //已加载模块列表
window.readyCOM = new Set()

//如果本地有缓存读取缓存
if (localStorage.getItem('allCOM')) {
    window.allCOM = JSON.parse(localStorage.getItem('allCOM'))
}
//统一服务器地址
window.globel_url = '/gateway'

/**
 *
 * http拦截
 *
 */
window.http = axios;

// 请求拦截器
axios.interceptors.request.use(function(config) {
    //如果有token设置header，不走登陆逻辑
    //配置ajax默认header
    // if (Vue.prototype.getCookie('accesstoken')) {
    //   let localtoken = JSON.parse(Vue.prototype.getCookie('accesstoken'))
    //   axios.defaults.headers.common['Authorization'] = `Bearer ${localtoken.access_token}`
    // }
    // console.log('config', config.headers['Authorization']);
    // console.log('axios.defaults.headers',axios.defaults.headers);
    if (!config.headers['Authorization']) {
        let localtoken = JSON.parse(Vue.prototype.getCookie('accesstoken'))
        let loginNameCookie = Vue.prototype.getCookie('loginName') ? Vue.prototype.getCookie('loginName') : '';
        let deviceIdCookie = Vue.prototype.getCookie('deviceId') ? Vue.prototype.getCookie('deviceId') : '';

        if (localtoken) {
            config.headers['Authorization'] = `Bearer ${localtoken.access_token}`
            config.headers["loginName"] = loginNameCookie;
            config.headers["deviceId"] = deviceIdCookie;
            config.headers["deviceType"] = "web";
        }
    }
    // 发送请求的信息
    return config
}, function(error) {
    // Do something with request error
    return Promise.reject(error)
})

// 返回响应拦截器
window.status208 = true;
axios.interceptors.response.use(function(response) {
    let data = response.data;
    let url = response.config.url
        //操作信息提示，排除请求模块js时返回的信息
    if (data && url != '/gateway/platform/operatingMarks') {
        if (data.showHits && data.message) {
            let type = 'success'
            let msg = data.message
            let time = 3000
            if (data.code === 30000) {
                msg = _.map(data.data, function(vv) {
                    return `<p>${vv}</p>`;
                }).join('')
            } else if (data.code === 20001) {
                // data.level = 'failmask';
                data.level = 'fail';
            }
            switch (data.level) {
                case 'info':
                    type = 'success'
                    break;
                case 'warn':
                    type = 'warning'
                    break;
                case 'fail':
                    type = 'error'
                    time = 10000
                    break;
                default:
                    msg = '未处理的其它 level: ' + data.level
            }
            Vue.prototype.$message({
                message: msg,
                type: type,
                duration: time,
                showClose: true,
            });
        }
    }
    //其他设备登录
    // console.log('response', response)
    if (status208 && response.status == 208) {
        status208 = false;
        Vue.prototype.$alert('此账号已在其它浏览器登录', '下线通知', {
            confirmButtonText: '确定',
            showClose: false,
            customClass: 'signoutDilog',
            callback: action => {
                Vue.prototype.logout();
            }
        });
        setTimeout(() => {
            $('.signoutDilog').parent('.el-message-box__wrapper').attr('style', 'z-index:7999');
            $('.signoutDilog').parent('.el-message-box__wrapper').nextAll('.v-modal').attr('style', 'z-index:7998');
        }, 500);
    }
    return response
}, function(error) {
    //token无效
    if (!error.response || (error.response.data.error == "invalid_token" || error.response.data.error == "unauthorized")) {
        //清除本地缓存重新登陆
        Vue.prototype.logout();
    }
    return Promise.reject(error)
})






/**
 *
 *
 * 初始化路由
 *
 */

//创建初始化路由
// import signin from './components/signin/index.vue'
// import framepage from './components/appframe/index.vue'

// window.router = new VueRouter({
//   routes: [{
//       name: 'signin',
//       path: '/signin',
//       component: signin,
//     },
//     {
//       name: 'framepage',
//       path: '/',
//       component: framepage,
//     }
//   ]
// })

//路由拦截
window.router.beforeEach((to, from, next) => {
    console.log('路由拦截beforeEach>>>>>>>>>>>>>>>>>', to.path)
    next()
})




/**
 *
 *
 * 初始化store
 *
 */
import './store'

/**
 *
 * 自定义导航方法
 *
 */

import './irouter'




//全局样式 线性图标用的css, 彩色图标用svg 需引入js
//阿里图标库 http://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.11&manage_type=myprojects&projectId=764310&keyword=
// http://at.alicdn.com/t/font_764310_k5r2cmq2ri.css,http://at.alicdn.com/t/font_814323_3e9xb7ug1vn.js
http.get('/gateway/platform/api/systemTool/config/HBD_ICONS_URL', {
    headers: {
        'Authorization': 'Basic YnJvd3Nlcjo='
    },
}).then(response => {
    if (response && response.data) {
        let str = response.data;
        let str2 = str.split(',');

        let reg = /\b(.js|.css)$\b/g;

        _.each(str2, i => {
            if (i.match(reg)) {
                if (i.match(reg) == '.css') {
                    let cssLink = document.createElement('link')
                    cssLink.rel = 'stylesheet';
                    cssLink.href = i;
                    document.getElementsByTagName('HEAD').item(0).insertBefore(cssLink, document.querySelector('#fontawesome'));
                }
                if (i.match(reg) == '.js') {
                    let jsLink = document.createElement('script')
                    jsLink.src = i;
                    document.getElementsByTagName('HEAD').item(0).insertBefore(jsLink, document.querySelector('#fontawesome'));
                }

            }
        })
    }
})

import './css/override-element-ui.css'
import './css/main.less'




/**
 *
 *
 * 初始化vue
 *
 */
window.appframe = new Vue({
    el: '#app',
    router,
    store: window.store,
    template: '<router-view/>',
})


// WEBPACK FOOTER //
// ./src/main.js